import { render } from "./EnbImgProd02.vue?vue&type=template&id=24a1630d&scoped=true"
import script from "./EnbImgProd02.vue?vue&type=script&lang=js"
export * from "./EnbImgProd02.vue?vue&type=script&lang=js"

import "./EnbImgProd02.vue?vue&type=style&index=0&id=24a1630d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a1630d"]])

export default __exports__